import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { FileListResult, GetUserFilesOpts } from '../interfaces/file';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FileControllerService {
  private readonly baseUrl: string = environment.BASE_API_URL;
  private readonly baseUrlWithoutBackend: string = environment.BASE_URL;

  constructor(
    private readonly http: HttpClient,
    @Inject(LOCALE_ID) private readonly localeId: string
  ) {}

  public getUserFiles(opts: GetUserFilesOpts): Observable<FileListResult> {
    if (
      opts.order_by &&
      opts.order_by !== 'created_at' &&
      opts.order_by !== '-created_at'
    ) {
      opts.order_by += ',-created_at';
    }
    if (!opts.page) {
      opts.page = 1;
    }

    // Shared URL construction logic
    let baseUrl =
      this.baseUrlWithoutBackend +
      'api/v1/current-user-files/?page=' +
      opts.page;

    if (opts.businessEntity) {
      baseUrl += '&business_entity=' + encodeURIComponent(opts.businessEntity);
    }
    if (opts.order_by) {
      baseUrl += '&ordering=' + opts.order_by;
    }
    if (opts.state) {
      baseUrl += '&state=' + opts.state;
    }
    baseUrl += '&lang=' + this.localeId;

    if (opts.unified) {
      const searchServiceUrl = `${baseUrl}&service=${encodeURIComponent(
        opts.unified
      )}`;
      const searchCompanyUrl = `${baseUrl}&company=${encodeURIComponent(
        opts.unified
      )}`;

      return forkJoin([
        this.http.get<FileListResult>(searchServiceUrl),
        this.http.get<FileListResult>(searchCompanyUrl)
      ]).pipe(
        map(([serviceResult, companyResult]) => ({
          count: serviceResult.count + companyResult.count,
          results: [...serviceResult.results, ...companyResult.results]
        }))
      ) as Observable<FileListResult>;
    }

    if (opts.service) {
      baseUrl += '&service=' + encodeURIComponent(opts.service);
    }
    if (opts.company) {
      baseUrl += '&company=' + encodeURIComponent(opts.company);
    }

    return this.http.get(baseUrl) as Observable<FileListResult>;
  }

  public delete(fileId: string) {
    return this.http.delete(`${this.baseUrl}files/${fileId}`);
  }
}
